import {
  MISMEDICOS_SUCCESS,
  MISMEDICOS_LOADING,
  MISMEDICOS_ERROR,
  MISMEDICOS_RESET,
  MISMEDICOS_ALTAENCUESTA,
  MISMEDICOS_RESETENCUESTA,
  MISMEDICOS_FLGRECARGAR,
  MISMEDICOS_FLGRECARGAR_RESET,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "../../../../global/helpers/axiosLogin";

/* export const wsGetMisMedicos =
  (idPacFamiliar, filtroFecha, nextStep) => (dispatch) => {
    dispatch({ type: MISMEDICOS_LOADING });
    axiosInstance().then((respuesta) => {
      respuesta
        .get(
          `/MisMedicos/${!idPacFamiliar ? "" : idPacFamiliar}/${
            !filtroFecha ? filtroFecha : ""
          }`
        )
        .then((resp) => {
          dispatch({
            type: MISMEDICOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: MISMEDICOS_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  }; */
export const wsGetMisMedicos =
  (idPacFamiliar, filtroFecha, nextStep) => (dispatch) => {
    dispatch({ type: MISMEDICOS_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `his/misMedicos/${!idPacFamiliar ? "" : idPacFamiliar}/${
            !filtroFecha ? filtroFecha : ""
          }`
        )
        .then((resp) => {
          dispatch({
            type: MISMEDICOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: MISMEDICOS_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  };

export const wsPostMisMedicos = (encuesta, nextStep) => (dispatch) => {
  dispatch({ type: MISMEDICOS_LOADING });
  axiosLogin().then((respuesta) => {
    respuesta
      .post("/shared/Encuesta/encuestaNew", encuesta)
      .then((resp) => {
        dispatch({
          type: MISMEDICOS_ALTAENCUESTA,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: MISMEDICOS_ERROR, payload: err.data });
        if (nextStep) nextStep(false, err.response.data);
      });
  });
};

export const wsPutMisMedicos = (idturno, encuesta, nextStep) => (dispatch) => {
  dispatch({ type: MISMEDICOS_LOADING });
  axiosLogin().then((respuesta) => {
    respuesta
      .put(`/shared/Encuesta/encuestaNew/${idturno}`, encuesta)
      .then((resp) => {
        dispatch({
          type: MISMEDICOS_ALTAENCUESTA,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: MISMEDICOS_ERROR, payload: err.data });
        if (nextStep) nextStep(false, err.response.data);
      });
  });
};

export const misMedicosReset = () => (dispatch) => {
  dispatch({
    type: MISMEDICOS_RESET,
  });
};

export const misMedicosResetEncuesta = () => (dispatch) => {
  dispatch({
    type: MISMEDICOS_RESETENCUESTA,
  });
};

export const recargaCardsMisMedicos = () => (dispatch) => {
  dispatch({
    type: MISMEDICOS_FLGRECARGAR,
    payload: true,
  });
};
export const resetRecargaCardsMisMedicos = () => (dispatch) => {
  dispatch({
    type: MISMEDICOS_FLGRECARGAR_RESET,
    payload: null,
  });
};
